import { Component, OnInit } from '@angular/core';
import {FadeZoomInTop} from "../../animations/fade-zoom-in-top.decorator";
import {UtilityService} from "../../utils/utility.service";
import {LayoutService} from "../layout.service";

@FadeZoomInTop()
@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./margin.css']
})
export class MainLayoutComponent implements OnInit {
  addMargin = false;
  constructor(private utilityService:UtilityService,
              private layout: LayoutService) { }

  ngOnInit() {
  }
  lockedMenu(event) {
    this.addMargin = event.lockedMenu;
  }

}
